/*
 * UserForm Messages
 *
 * This contains all the text for the UserForm component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  firstName: {
    id: 'app.components.UserForm.firstName',
    defaultMessage: 'First name',
  },
  middleName: {
    id: 'app.components.UserForm.middleName',
    defaultMessage: 'Middle name',
  },
  lastName: {
    id: 'app.components.UserForm.lastName',
    defaultMessage: 'Last name',
  },
  email: {
    id: 'app.components.UserForm.email',
    defaultMessage: 'Email',
  },
  gender: {
    id: 'app.components.UserForm.gender',
    defaultMessage: 'Gender',
  },
  male: {
    id: 'app.components.UserForm.male',
    defaultMessage: 'Male',
  },
  female: {
    id: 'app.components.UserForm.female',
    defaultMessage: 'Female',
  },
  partner: {
    id: 'app.components.UserForm.partner',
    defaultMessage: 'Partner',
  },
  phone: {
    id: 'app.components.UserForm.phone',
    defaultMessage: 'Phone',
  },
  birthDate: {
    id: 'app.components.UserForm.birthDate',
    defaultMessage: 'Birth Date',
  },
  congregation: {
    id: 'app.components.UserForm.congregation',
    defaultMessage: 'Congregation',
  },
  vip: {
    id: 'app.components.UserForm.vip',
    defaultMessage: 'VIP',
  },
  pioneer: {
    id: 'app.components.UserForm.pioneer',
    defaultMessage: 'Pioneer',
  },
  shiftLeader: {
    id: 'app.components.UserForm.shiftLeader',
    defaultMessage: 'Team leader',
  },
  administrator: {
    id: 'app.components.UserForm.administrator',
    defaultMessage: 'Administrator',
  },
  publisher: {
    id: 'app.components.UserForm.publisher',
    defaultMessage: 'Publisher',
  },
  invalidPhoneNumber: {
    id: 'app.components.UserForm.invalidPhoneNumber',
    defaultMessage: 'Invalid phone number',
  },
  pioneerLevel: {
    id: 'app.components.UserForm.pioneerLevel',
    defaultMessage: 'Pioneer Level',
  },
  regularPioneer: {
    id: 'app.components.UserForm.regularPioneer',
    defaultMessage: 'Regular Pioneer',
  },
  sepcialPioneer: {
    id: 'app.components.UserForm.sepcialPioneer',
    defaultMessage: 'Special Pioneer',
  },
  circuitOverseer: {
    id: 'app.components.UserForm.circuitOverseer',
    defaultMessage: 'Circuit Overseer',
  },
  noPioneer: {
    id: 'app.components.UserForm.noPioneer',
    defaultMessage: 'No Pioneer',
  },
  privilege: {
    id: 'app.components.UserForm.privilege',
    defaultMessage: 'Privilege',
  },
  elder: {
    id: 'app.components.UserForm.elder',
    defaultMessage: 'Elder',
  },
  ministerialServant: {
    id: 'app.components.UserForm.ministerialServant',
    defaultMessage: 'Ministerial Servant',
  },
  none: {
    id: 'app.components.UserForm.none',
    defaultMessage: 'None',
  },
  roles: {
    id: 'app.components.UserForm.roles',
    defaultMessage: 'Roles',
  },
  experience: {
    id: 'app.components.UserForm.experience',
    defaultMessage: 'Experience',
  },
  newbie: {
    id: 'app.components.UserForm.newbie',
    defaultMessage: 'Newbie',
  },
  common: {
    id: 'app.components.UserForm.common',
    defaultMessage: 'Common',
  },
  mentor: {
    id: 'app.components.UserForm.mentor',
    defaultMessage: 'Mentor',
  },
});
